<template>
	<div>
		<vx-card title="Factuuradres" class="text-md" noShadow cardBorder>
			<template slot="actions">
				<print-billing-label :order="this.order" :dymo-printer="this.dymoPrinter" />
			</template>
			{{ order.billing.company }}<br>
			{{ order.billing.full_name }}<br>
			{{ order.billing.full_address }}<br>
			{{ order.billing.zip_code }} {{ order.billing.city }}<br>
			<p v-if="order.billing.country_code === 'NL'">
				Nederland<br>
			</p>
			<p v-if="order.billing.country_code === 'BE'">
				België<br>
			</p>
			<a :href="`mailto:${order.billing.email}?subject=${order.order.type_email_subject}&body=Beste ${order.billing.full_name},`">Email klant</a><br>
		</vx-card>
	</div>
</template>

<script>
import dymoPrinter from '@/services/dymo/dymoPrinter';
import PrintBillingLabel from '@/views/orderDetails/printBillingLabel';

export default {
	components: {
		PrintBillingLabel
	},
	props: {
		order: Object,
		dymoPrinter: {
			type: dymoPrinter,
			required: true
		}
	},
}
</script>
